module.exports = __webpack_public_path__ + "static/media/Informationbanner@3x.27883f3b.png";